<script setup lang="ts">
import { useI18n, type Locale } from '@/i18n'

defineProps<{
  compact?: boolean
  inverse?: boolean
}>()

const { locale, setLocale, t } = useI18n()

const selectLocale = (nextLocale: Locale) => setLocale(nextLocale)
</script>

<template>
  <div
    class="inline-flex items-center rounded-lg border p-0.5"
    :class="inverse ? 'border-white/30 bg-white/10' : 'border-gray-200 bg-gray-50'"
    role="group"
    :aria-label="t('Language')"
  >
    <svg
      v-if="!compact"
      class="ml-1.5 mr-1 h-4 w-4"
      :class="inverse ? 'text-white/80' : 'text-gray-400'"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M16 21l4-9 4 9M6.5 17c2.238 0 4.187-1.223 5.224-3.036M4 13.5c1.314 0 2.532-.397 3.545-1.077" />
    </svg>
    <button
      type="button"
      class="rounded-md px-2 py-1 text-xs font-semibold transition-colors"
      :class="locale === 'en'
        ? (inverse ? 'bg-white text-blue-700 shadow-sm' : 'bg-white text-blue-600 shadow-sm')
        : (inverse ? 'text-white/80 hover:bg-white/10' : 'text-gray-500 hover:text-gray-700')"
      :aria-pressed="locale === 'en'"
      :title="t('English')"
      @click="selectLocale('en')"
    >
      EN
    </button>
    <button
      type="button"
      class="rounded-md px-2 py-1 text-xs font-semibold transition-colors"
      :class="locale === 'th'
        ? (inverse ? 'bg-white text-blue-700 shadow-sm' : 'bg-white text-blue-600 shadow-sm')
        : (inverse ? 'text-white/80 hover:bg-white/10' : 'text-gray-500 hover:text-gray-700')"
      :aria-pressed="locale === 'th'"
      :title="t('Thai')"
      @click="selectLocale('th')"
    >
      ไทย
    </button>
  </div>
</template>
